export function dateFormat(date) {
  const dateTime = `${date}`;
  let dateFormated = '';
  dateTime.includes('T');

  if (dateTime.includes('T')) {
    // 15 de setembro, 2021 11:51 am
    const timeZone = Date.parse(date);
    const formatDate = new Date(timeZone).toLocaleDateString('pt-BR');
    const formatTime = new Date(timeZone).toLocaleTimeString('pt-BR');

    dateFormated = `${formatDate} - ${formatTime}`;
  } else if (date) {
    const formatDate = new Date(date).toLocaleDateString('pt-BR');
    const formatTime = new Date(date).toLocaleTimeString('pt-BR');

    dateFormated = `${formatDate} - ${formatTime}`;
  }

  return dateFormated;
}
